module.exports = __webpack_public_path__ + "static/AboutUs-b61afae830ab42793ca0f1f6da1036d2.png";